const filterChannel = (channels, lang) =>
  channels.filter(channel => channel.lang.toString() === lang.toString());

const filterLanguage = function checkToSeeIfLanguageHasPlaylist(pageData) {
  const data = pageData;
  const filteredChannel = filterChannel(data.channelIds, data.languageId);
  if (!filteredChannel[0]) {
    data.languageId = '1';
    data.channel = filterChannel(data.channelIds, data.languageId)[0].id;
  } else {
    data.channel = filteredChannel[0].id;
  }
  delete data.channelIds;
  return data;
};

export default filterLanguage;



// WEBPACK FOOTER //
// ./src/components/filterLanguage.js